import React, { useState } from "react";
import CustomizedTextField from "orion-components/SharedComponents/CustomizedTextField/CustomizedTextField";
import { CheckMark, Close } from "orion-components/CBComponents/Icons";
import { getDir } from "orion-components/i18n/Config/selector";
import { useSelector } from "react-redux";
import { generateDirStyles } from "../../../SharedComponents/GenerateDirStyles/GenerateDirStyles";
import Tooltip from "@mui/material/Tooltip";

const baseStyles = {
	container: {
		width: "100%",
		height: 32,
		display: "flex",
		alignItems: "center",
		background: "#5D646A",
		borderRadius: "4px",
		paddingLeft: 28,
		paddingRight: 12
	},
	wrapper: {
		width: "100%",
		height: 20,
		display: "flex",
		alignItems: "center"
	},
	textFieldWrapper: {
		flexGrow: 1,
		width: "85%",
		display: "flex"
	},
	buttonWrapper: {
		display: "flex",
		alignItems: "center",
		flexShrink: 0,
		marginLeft: 8
	}
};

const ignoreTransformingStyles = {
	container: { alignItems: true },
	wrapper: { alignItems: true },
	buttonWrapper: { alignItems: true }
};

const EditGroupNode = ({ node, clearSelectedNodeForEdit, addOrUpdateNodeLabel }) => {
	const [name, setName] = useState(node?.name);
	const [showError, setShowError] = useState(false);
	const dir = useSelector((state) => getDir(state));
	const styles = generateDirStyles(baseStyles, dir, ignoreTransformingStyles);

	const handleSave = (event) => {
		if (event) {
			event.stopPropagation();

			//Prevent the default behavior if the event is a form submission or a link click
			event.preventDefault();
		}

		//The following restricts adding an empty group name to the parent groups.
		const trimmedName = name.trim();

		if (!trimmedName) {
			setShowError(true);
			return;
		}

		addOrUpdateNodeLabel(node.id, {
			...node,
			name: trimmedName
		});
		clearSelectedNodeForEdit(event || { stopPropagation: () => {}, preventDefault: () => {} }, node);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			e.stopPropagation();
			handleSave(e);
		}

		if (e.key === "Escape") {
			e.preventDefault();
			e.stopPropagation();
			clearSelectedNodeForEdit(e, node);
		}
	};

	return (
		<div style={styles.container}>
			<div style={styles.wrapper}>
				<div style={styles.textFieldWrapper}>
					<CustomizedTextField
						variant="outlined"
						fullWidth
						customHeight={20}
						customNotchHeight={26}
						value={name}
						customWidth="100%"
						onClick={(event) => {
							event.stopPropagation();
							event.preventDefault();
						}}
						onChange={(event) => {
							event.stopPropagation();
							event.preventDefault();
							setShowError(false);
							setName(event.target.value);
						}}
						onKeyDown={handleKeyDown}
						customBgColor="#3B4045" data-testid="orion-components-device-manager-device-tree-components-edit-group-node-customized-text-field"
					/>
				</div>

				{node?.isGroup && (
					<div style={styles.buttonWrapper} id="device_tree_action_buttons">
						<Tooltip
							title="Name cannot be blank"
							open={showError}
							disableHoverListener
							disableFocusListener
							disableTouchListener data-testid="orion-components-device-manager-device-tree-components-edit-group-node-tooltip"
						>
							<div onClick={(e) => {handleSave(e)}} style={{ padding: "0px 8px" }} data-testid="orion-components-device-manager-device-tree-components-edit-group-node-div">
								<CheckMark />
							</div>
						</Tooltip>

						<div onClick={(e) => clearSelectedNodeForEdit(e, node)} style={{ padding: "0px 8px" }} data-testid="orion-components-device-manager-device-tree-components-edit-group-node-div-2">
							<Close />
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default EditGroupNode;
